import { reverseMessages } from "../utils/chat-message";
import Axios from "../utils/http-request";
import { getAccessToken } from "../utils/storage";

export const apiPostMessage = async (values: {
  receiver_id: number;
  message: string;
}) => {
  const formData = JSON.stringify(values);
  // Get access token
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/chats/send`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};

export const apiPostReadMessage = async (chat_id: number) => {
  // Get access token
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/chats/read/${chat_id}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.post(uri, {}, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};

export const apiGetCharts = async () => {
  // Get access token
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/chats`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const apiGetAChart = async (params: {
  chat_id: number;
  page: number;
  page_size: number;
}) => {
  // Get access token
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/chats/${params.chat_id}?page=${params.page}&page_size=${params.page_size}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const fetchAllChats = async () => {
  try {
    const response = await apiGetCharts();

    if (response.status === "error") {
      console.error("Error creating reply");
    }

    return response.data || [];
  } catch (error) {
    console.error("Error adding reply:", error);
    return [];
  }
};

export const fetchChat = async (params: {
  chat_id: number;
  page: number;
  page_size: number;
}) => {
  try {
    const response = await apiGetAChart(params);

    if (response.status === "error") {
      console.error("Error creating reply");
    }

    return reverseMessages(response.data || []);
  } catch (error) {
    console.error("Error adding reply:", error);
    return [];
  }
};

export const sendPostMessage = async (values: {
  receiver_id: number;
  message: string;
}) => {
  try {
    const response = await apiPostMessage(values);

    if (response.status === "error") {
      console.error("Error creating reply");
      return false;
    }
    if (response.status === 204) {
      return true;
    }
  } catch (error) {
    console.error("Error adding reply:", error);
    return false;
  }
};
